<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="backButtonRoute ? true : false"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :tabs="[]"
    :selectedIndex="undefined"
    ref="gc-base-layout"
  >
    <slot> </slot>
    <template #headerContent>
      <GcHeaderContentDynamic
        :title="getScreenJson.title"
        :createModeIsEditMode="true"
        :baseView="baseView"
        :primaryLabel="'Primary Label'"
        :secondaryLabel="'Secondary Label'"
        v-if="loaded"
      />
    </template>
    <gc-header-form
      :headerOptions="getHeaderScreenJson"
      :data="loaded ? model : {}"
      :saveTransaction="saveTransaction"
      :backButtonRoute="backButtonRoute"
      ref="gc-header-form-component"
      :getHeaderToolbar="undefined"
      :setLoading="showLoading"
      v-show="!gridExpand"
    ></gc-header-form>
    <div>
      <dx-data-grid
        :data-source="dataGridLocalItemDataSource"
        :columns="getProductEntryColumns"
        :height="getGridHeight"
        :column-chooser="{ enabled: false }"
        :ref="'dx-data-grid-comp'"
        :key-expr="'ID'"
        :repaint-changes-only="true"
        :show-borders="true"
        :two-way-binding-enabled="false"
        :focusedRowEnabled="true"
        @toolbar-preparing="onToolbarPreparing($event)"
      >
        <!-- <DxPaging :enabled="false" /> 
          :allow-deleting="baseView.mode != 'review'"-->
        <DxEditing
          :allow-updating="baseView.mode != 'review'"
          :allow-deleting="baseView.mode != 'review'"
          mode="cell"
          :new-row-position="'last'"
        />

        <DxKeyboardNavigation
          :edit-on-key-press="true"
          :enter-key-action="'startEdit'"
          :enter-key-direction="'none'"
          :enabled="true"
        />

        <DxPaging :page-size="200" :enabled="true" />

        <template #menu-cell-template="{ data }">
          <DxDropDownButton
            :items="[
              { menuText: 'Line Comment', data: data },
              { menuText: 'Item History', data: data },
            ]"
            keyExpr="menuText"
            displayExpr="menuText"
            :drop-down-options="{ width: 250 }"
            class="gc-dropdown-icon-button"
            :id="data.data.ID"
            :icon="'overflow'"
            styling-mode="text"
            :show-arrow-icon="false"
            :onItemClick="onSoDetailsLineContextMenuItemClick"
            :disabled="!data.data.ItemCode"
          />
        </template>

        <!-- <DxSummary>
          <DxTotalItem
            :summary-type="'sum'"
            :value-format="'##,###,##0.00'"
            :name="'SalesUMNetFXPrice'"
            display-format="{0}"
            :show-in-column="'SalesUMNetFXPrice'"
            column="SalesUMNetFXPrice"
          />
          <DxTotalItem
            :summary-type="'sum'"
            :value-format="'##,###,##0.00'"
            :name="'TaxFXLineTotal'"
            display-format="{0}"
            :show-in-column="'TaxFXLineTotal'"
            column="TaxFXLineTotal"
          />

          <DxTotalItem
            column="TaxableFXLineTotal"
            :summary-type="'sum'"
            :value-format="'##,###,##0.00'"
            :name="'TaxableFXLineTotal'"
            display-format="{0}"
            :show-in-column="'TaxableFXLineTotal'"
          />
        </DxSummary> -->
      </dx-data-grid>
    </div>

    <GcFooter v-if="showFooter">
      <template #leftContent>
        <div
          class="gc-grid-footer-item"
          v-for="item in footerLeftItems"
          :key="item.label"
        >
          <label class="gc-footer-label">{{ item.label }}</label>

          <label
            v-if="item.fieldType == 'custome-string'"
            class="gc-footer-value"
            >{{ item.value }}</label
          >
          <GcFooterItem
            :value="item.value"
            :format="item.format"
            :length="item.format == 'Decimal-16-4C' ? 8 : 6"
            v-else
          />
        </div>
      </template>
      <template #rightContent>
        <div
          class="gc-grid-footer-item"
          v-for="item in footerRightItems"
          :key="item.label"
        >
          <label class="gc-footer-label">{{ item.label }}</label>
          <GcFooterItem
            :value="item.value"
            :format="item.format"
            :length="item.format == 'Decimal-16-4C' ? 8 : 6"
          />
        </div>
      </template>
    </GcFooter>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import DataGridMixin from "@/_mixins/data-grid.mixin";
import { getGlobalField } from "../../_store/helpers";
import { ProductService } from "../../_services/api/products/product.service";
import { mapGetters } from "vuex";

import ArrayStore from "devextreme/data/array_store";
import validationEngine from "devextreme/ui/validation_engine";

export default {
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  components: {},
  data() {
    return {
      loaded: false,
      model: {
        Status: "D",
        CustomStatus: "Credit Hold",
      },
      dataGridLocalItemDataSource: new ArrayStore({
        key: "ID",
        data: [],
      }),
      showFooter: true,
      footerItems: [],
    };
  },

  async created() {},
  async mounted() {
    this.showLoading(true);
    this.initialized();
  },
  beforeDestroy() {
    this.$store.dispatch("dataContext/setSearchText", undefined);
  },

  computed: {
    ...mapGetters({ gridHeight: "ui/getHeightForDataGrid" }),
    ...mapGetters({ headerFormHeight: "ui/getHeaderFormHeight" }),
    ...mapGetters({ gridExpand: "ui/getGridExpand" }),
    ...mapGetters({
      getValidationSummaryVisible: "ui/getValidationSummaryVisible",
    }),

    getGridHeight() {
      if (this.headerFormHeight)
        return (
          this.gridHeight - (this.gridExpand ? 6 : this.headerFormHeight) - 50
        );
      else return this.gridHeight - 50;
    },
    backButtonRoute() {
      return "/sales-order";
    },
    getScreenJson() {
      var screenJson = {
        title: "Screen Name",
      };
      return screenJson;
    },
    getHeaderScreenJson() {
      return {
        headerFormVisible: true,
        headerToolbar: {
          audit: this.baseView.mode == "review",
          status: true,
          // notes: true,
          // notesItems: ["Order Comments", "Order Notes"],
          save: true,
          // editURL: "/sales-order-v4",
          // saveOptions: {
          //   items: this.baseView.id
          //     ? [
          //         { text: "Draft", id: "D" },
          //         { text: "Commit", id: "A" },
          //         { text: "Cancel", id: "X" },
          //       ]
          //     : [
          //         { text: "Draft", id: "D" },
          //         { text: "Commit", id: "A" },
          //       ],
          //   keyExpr: "id",
          //   displayExpr: "text",
          //   dropDownOptions: {
          //     width: "150px",
          //   },
          //   saveKey: "NextStatus",
          // },
          saveCallback: this.saveSalesOrder,
          screenName: "Screen Name", // Ex : Sales Orders - All
          pdf: this.baseView.mode == "review",

          toolbarFormItems: [
            {
              screenField: "Customer",
              dataField: "CustomerCode",
              cssClass: "toolbar-customer-label",
              editorOptions: {
                dropDownOptions: {
                  minWidth: 300,
                },
                width: 300,
                placeholder: "Customer Name",
                // onValueChanged: this.onCustomerCodeValueChanged.bind(this),
                showClearButton: true,
                // onItemClick: this.onCustomerCodeItemClicked.bind(this),
              },
              label: {
                text: "Customer",
                visible: false,
              },
              required: true,
            },
          ],
          // formContentReady: this.toolBarFormContentReady,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    // // disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    // disabled: true,
                  },
                },
              ],
            },
          ],
          customStatus: {
            enabled: true,
            key: "CustomStatus",
          },
        },
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 3,
            items: [
              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    screenField: "DateIn",
                    label: {
                      text: "Date In",
                    },
                    dataField: "DateIn",
                    required: true,
                    editorOptions: {
                      // onValueChanged: this.onDateInValueChanged.bind(this),
                    },
                  },
                  {
                    screenField: "RequiredDate",
                    label: {
                      text: "Reqd Date",
                    },
                    dataField: "RequiredByDate",
                    required: true,
                    editorOptions: {
                      // onValueChanged:
                      //   this.onRequiredByDateValueChanged.bind(this),
                    },
                  },
                ],
              },
              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    screenField: "ConNote",
                    dataField: "ConsignmentNo",
                  },
                  {
                    screenField: "CurrencyCode",
                    dataField: "CurrencyCode",
                    editorOptions: {
                      readOnly: true,
                    },
                  },
                  {
                    screenField: "ExchangeRate",
                    dataField: "ExchangeRate",
                    editorOptions: {
                      // TODO: Check the ReadOnly Logic
                      readOnly: true,
                      // onValueChanged: this.onExchangeValueChanged,
                    },
                    required: true,
                    // validationRules: [
                    //   {
                    //     type: "custom",

                    //     validationCallback: ({ value, rule }) => {
                    //       rule.message = `Exchange rate Cannot be 0 or Negative`;
                    //       return value > 0;
                    //     },
                    //   },
                    // ],
                  },
                ],
              },

              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    screenField: "Branch",
                    label: {
                      text: "Branch",
                    },
                    dataField: "BranchCode",
                    required: true,
                    editorOptions: {
                      // onValueChanged: async (e) => {
                      //   await this.getSalesUMs(e.value);
                      //   this.triggerPriceChange(e);
                      // },
                    },
                  },
                  {
                    screenField: "Division",
                    label: {
                      text: "Division",
                    },
                    dataField: "DivisionCode",
                    required: true,
                    editorOptions: {
                      // onValueChanged: this.triggerPriceChange.bind(this),
                    },
                  },
                  {
                    // dataField: "SalesOrderTypeDescription",
                    screenField: "OrderType",
                    required: true,
                    editorOptions: {
                      // onValueChanged: (e) => {
                      //   if (e.event) this.setOrderComments(e.value);
                      //   this.triggerPriceChange(e);
                      // },
                    },
                  },
                  {
                    screenField: "OrderRep",
                    dataField: "SalesRepresentativeCode",
                    label: {
                      text: "Sales Rep",
                    },
                    required: true,
                    // defaultValue: this.getDefaultSalesRep,
                  },
                ],
              },
            ],
          },
        ],
      };
    },
    getProductEntryColumns() {
      return [
        {
          caption: "Product",
          dataField: "ProductCode",
          showEditorAlways: this.baseView.mode != "review",
          allowSearch: false,
          allowSorting: false,
          allowEditing: this.baseView.mode != "review",
          minWidth: 250,
          visible: this.dataViewType != "review",
          cssClass: "edit-cell-textbox-field",
          editorOptions: {
            onFocusIn: async (e) => {
              const headerToolbarForm = await validationEngine.validateGroup(
                "gc-form-header-toolbar"
              );
              if (!headerToolbarForm.isValid) {
                this.setValidationComeBack("Customer");
                this.displayValidationSummary(headerToolbarForm.brokenRules);
              } else e.event.target.select();
            },
            onKeyDown: async (e) => {
              if (e.event.key == "Enter") {
                setTimeout(() => {
                  if (this.getValidationSummaryVisible) return;
                  // var dataGrid = this.$refs["dx-data-grid-comp"].instance;

                  var dataGrid = this.$refs["dx-data-grid-comp"].instance;
                  if (
                    !this.productEntryLocalItems._array[
                      this.productEntryLocalItems._array.length - 1
                    ].ProductCode
                  ) {
                    setTimeout(() => {
                      var rowIndex = dataGrid.getRowIndexByKey(
                        this.productEntryLocalItems._array[
                          this.productEntryLocalItems._array.length - 1
                        ].ID
                      );

                      var cellElement = dataGrid.getCellElement(
                        rowIndex,
                        "ProductCode"
                      );
                      dataGrid.focus(cellElement);
                      dataGrid.editCell(rowIndex, "ProductCode");
                    }, 100);
                  } else {
                    var maxID = Math.max(
                      ...this.productEntryLocalItems._array.map((e) => e.ID)
                    );
                    let dataObj = Object.assign(
                      { IsCopyLine: false, IsNewLine: true },
                      // eslint-disable-next-line no-undef
                      productEntryBase
                    );
                    dataObj.ID = ++maxID;

                    // this.productEntryLocalItems.push([
                    //   { type: "insert", data: dataObj },
                    // ]);

                    this.updateLocalDataSet("insert", dataObj);

                    // dataGrid.refresh(true);
                  }
                }, 10);
              }
            },
          },
          setCellValue: (newData, value, currentRowData) => {
            if (!value) return;
            // if (!this.model.CustomerCode) {
            //   newData.ProductCode = undefined;
            //   this.validationLineData = "Customer";
            //   this.displayValidationErrors(["Customer is required"]);
            // } else {

            var index = this.productDataSourceItems.findIndex(
              (x) => x.ItemCode == value
            );
            if (index == -1) {
              if (!this.productItemsLoaded) {
                this.showLoading(true);
                ProductService.getCustomData({
                  url: "api/ProductFilterGroupSaleItemCompanyBranch",
                  top: 1,
                  filter: `ItemCode eq '${value}' and ItemType eq 'S' and IsDefault eq 'Y' and AvailableForSale eq 'Y' and BranchCode eq '${this.model.BranchCode}' and CustomerCode eq '${this.model.CustomerCode}' and Inactive eq 'N'`,
                })
                  .then((res) => {
                    this.showLoading(false);
                    if (res.data.value.length > 0) {
                      var productItem = res.data.value[0];
                      this.addItemToProductDataSource(productItem);
                      newData.ProductCode = value;
                      // var productItem = this.productDataSourceItems[index];
                      newData.ProductDescription = productItem.Description1;

                      newData.ProductDescription = productItem.Description1;
                      newData.SalesUM = productItem.SalesUM;
                      newData.ItemCode = productItem.ItemCode;
                      newData.Code = productItem.ItemCode;
                      newData.ItemType = productItem.ItemType;
                      newData.validCode = productItem.ItemCode;
                      newData.IsNewLine = false;

                      newData.ID = currentRowData.ID;
                      this.updateLocalDataSet("update", newData);

                      if (currentRowData.SalesUMQty > 0) {
                        newData.SalesUMQty = currentRowData.SalesUMQty;
                        this.getItemPriceDetails(newData, { ...newData });
                      }
                    } else {
                      if (currentRowData.validCode)
                        newData.ProductCode = currentRowData.validCode;

                      this.updateLocalDataSet("update", currentRowData);
                      this.$store.dispatch(
                        "ui/setValidationSummaryVisible",
                        true
                      );
                      this.setValidationComeBack("Product", currentRowData.ID);
                      this.displayValidationErrors([
                        "This Product does not exist. Please try again",
                      ]);
                    }
                  })
                  .catch((err) => {
                    if (err);
                    this.showLoading(false);
                  });
              } else {
                if (currentRowData.validCode)
                  newData.ProductCode = currentRowData.validCode;

                this.updateLocalDataSet("update", currentRowData);
                this.$store.dispatch("ui/setValidationSummaryVisible", true);
                this.setValidationComeBack("Product", currentRowData.ID);
                this.displayValidationErrors([
                  "This Product does not exist. Please try again",
                ]);
              }
            } else {
              newData.ProductCode = value;
              var productItem = this.productDataSourceItems[index];
              newData.ProductDescription = productItem.Description1;

              newData.ProductDescription = productItem.Description1;
              newData.SalesUM = productItem.SalesUM;
              newData.ItemCode = productItem.ItemCode;
              newData.Code = productItem.ItemCode;
              newData.ItemType = productItem.ItemType;
              newData.validCode = productItem.ItemCode;
              newData.IsNewLine = false;

              if (currentRowData.SalesUMQty > 0) {
                newData.ID = currentRowData.ID;
                newData.SalesUMQty = currentRowData.SalesUMQty;
                this.getItemPriceDetails(newData, { ...newData });
              }
            }
            // }
          },
          // renderAsync: true,
        },
        {
          caption: "Description",
          dataField: "ProductDescription",
          allowEditing: false,
          // renderAsync: true,
        },
        {
          caption: "Sales UM",
          dataField: "SalesUM",
          allowEditing: false,
          // renderAsync: true,
        },
        {
          caption: "Quantity",
          dataField: "SalesUMQty",
          allowEditing: this.baseView.mode != "review",
          showEditorAlways: this.baseView.mode != "review",
          format: "##,###,###,###,##0.00",
          // renderAsync: true,
          cssClass: "edit-cell-numberbox-field",
          editorOptions: {
            format: "##,###,###,###,##0.00",
            onFocusIn: (e) => {
              e.event.target.select();
            },
            onKeyDown: async (e) => {
              if (e.event.key == "Enter") {
                var dataGrid = this.$refs["dx-data-grid-comp"].instance;
                if (
                  !this.productEntryLocalItems._array[
                    this.productEntryLocalItems._array.length - 1
                  ].ProductCode
                ) {
                  setTimeout(() => {
                    var rowIndex = dataGrid.getRowIndexByKey(
                      this.productEntryLocalItems._array[
                        this.productEntryLocalItems._array.length - 1
                      ].ID
                    );

                    var cellElement = dataGrid.getCellElement(
                      rowIndex,
                      "ProductCode"
                    );
                    dataGrid.focus(cellElement);
                    dataGrid.editCell(rowIndex, "ProductCode");
                  }, 100);
                } else {
                  var maxID = Math.max(
                    ...this.productEntryLocalItems._array.map((e) => e.ID)
                  );
                  let dataObj = Object.assign(
                    { IsCopyLine: false, IsNewLine: true },
                    // eslint-disable-next-line no-undef
                    productEntryBase
                  );
                  dataObj.ID = ++maxID;

                  // this.productEntryLocalItems.push([
                  //   { type: "insert", data: dataObj },
                  // ]);

                  this.updateLocalDataSet("insert", dataObj);

                  // dataGrid.refresh(true);
                }
              }
            },
            onValueChanged: this.onSalesUMQtyValueChanged,
            step: 0,
          },
          // setCellValue: async (newData, value, currentRowData) => {
          //   console.log(
          //     "newData, value, currentRowData",
          //     newData,
          //     value,
          //     currentRowData
          //   );
          //   newData.SalesUMQty = value;
          //   newData.ID = currentRowData.ID;
          //   this.getItemPriceDetails(newData, { ...currentRowData });
          // },
        },
        {
          caption: "Price",
          dataField: "SalesUMFXPrice",
          allowEditing: false,
          format: "##,###,###,###,##0.00",
          // renderAsync: true,
        },
        {
          caption: "Discount",
          dataField: "DiscPcnt",
          allowEditing: this.baseView.mode != "review",
          showEditorAlways: this.baseView.mode != "review",
          cssClass: "edit-cell-numberbox-field",
          // renderAsync: true,
          editorOptions: {
            onFocusIn: (e) => {
              e.event.target.select();
            },
            onValueChanged: this.onDiscPcntValueChanged,
            format: "##,###,###,###,##0.00 '%'",

            onKeyDown: async (e) => {
              if (e.event.key == "Enter") {
                var maxID = Math.max(
                  ...this.productEntryLocalItems._array.map((e) => e.ID)
                );
                let dataObj = Object.assign(
                  { IsCopyLine: false, IsNewLine: true },
                  // eslint-disable-next-line no-undef
                  productEntryBase
                );
                dataObj.ID = ++maxID;

                // this.productEntryLocalItems.push([
                //   { type: "insert", data: dataObj },
                // ]);
                this.updateLocalDataSet("insert", dataObj);
              }
            },
          },
        },
        {
          caption: "Net Price",
          dataField: "SalesUMNetFXPrice",
          allowEditing: false,
          format: "##,###,###,###,##0.00",
          // renderAsync: true,
        },
        {
          caption: "Tax",
          dataField: "TaxFXLineTotal",
          allowEditing: false,
          format: "##,###,###,###,##0.00",
        },
        {
          caption: "Total",
          dataField: "TaxableFXLineTotal",
          allowEditing: false,
          format: "##,###,###,###,##0.00",
          // renderAsync: true,
        },
        {
          caption: "",
          dataField: "",
          type: "buttons",
          buttons: ["delete"],
          visible: this.baseView.mode != "review",
        },
        {
          caption: "",
          dataField: "",
          width: 40,
          minWidth: 30,
          maxWidth: 80,
          allowEditing: false,
          cellTemplate: "menu-cell-template",
          alignment: "left",
          cssClass: "more-menu",
          fixedPosition: "right",
          fixed: true,
          allowFixing: true,
          allowReordering: false,
          allowSorting: false,
          allowSearch: false,
          allowFiltering: false,
          allowGrouping: false,
        },
      ];
    },
    // Footer
    getFooterItems() {
      return [
        {
          screenField: "SalesUMItemCount",
          dataField: "SalesUMQty",
          location: "left",
          value: 0,
        },
        {
          screenField: "FXLineTotal",
          dataField: "TaxableFXLineTotal",
          location: "right",
          value: 0,
          format: "Decimal-16-4C",
          label: `Sub Total (${this.model.CurrencyCode})`,
        },
        {
          screenField: "TaxFXTotal",
          dataField: "TaxFXLineTotal",
          location: "right",
          value: 0,
          format: "Decimal-16-4C",
          label: `Tax (${this.model.CurrencyCode})`,
        },
        {
          screenField: "FXTotal",
          dataField: "FXLineTotal",
          location: "right",
          value: 0,
          format: "Decimal-16-4C",
          label: `Total (${this.model.CurrencyCode})`,
        },
      ];
    },

    footerLeftItems() {
      var leftItems = this.footerItems.filter((x) => x.location == "left");

      return leftItems
        .map((c) => {
          let globalField = { ...getGlobalField(c.screenField) };
          if (Object.keys(globalField).length == 0) return c;

          if (c.value != undefined) globalField.value = c.value;
          if (c.dataField != undefined) globalField.dataField = c.dataField;
          if (c.label != undefined) globalField.label = c.label;
          if (c.format != undefined) globalField.format = c.format;
          if (c.fieldType != undefined) globalField.fieldType = c.fieldType;
          if (c.length != undefined) globalField.length = c.length;
          if (globalField.type === "Decimal") {
            globalField.label = globalField.label.replace(
              "(Customer Currency)",
              `(${this.model.CurrencyCode})`
            );
          }
          // if(c.length != undefined) globalField.length = c.length;
          if (globalField.type === "Decimal") {
            globalField.label = globalField.label.replace(
              "(Customer Currency)",
              `(${this.model.CurrencyCode})`
            );
          }
          if (globalField) return globalField;
          else return c;
        })
        .filter((x) => x != null);
    },
    footerRightItems() {
      // return this.footerItems.filter((x) => x.location == "right");
      var rightItems = this.footerItems.filter(
        (x) =>
          x.location == "right" &&
          (x.hasOwnProperty("visible") ? x.visible : true)
      );

      return rightItems
        .map((c) => {
          let globalField = { ...getGlobalField(c.screenField) };

          if (Object.keys(globalField).length == 0) return c;

          if (c.value != undefined) globalField.value = c.value;
          if (c.dataField != undefined) globalField.dataField = c.dataField;
          if (c.label != undefined) globalField.label = c.label;
          if (c.format != undefined) globalField.format = c.format;

          if (globalField.type === "Decimal") {
            globalField.label = globalField.label.replace(
              "(Customer Currency)",
              `(${this.model.CurrencyCode})`
            );
          }

          if (globalField) return globalField;
          else return c;
        })
        .filter((x) => x != null);
    },
  },
  methods: {
    async updateLocalDataSet(type, dataObj) {
      if (type == "insert") {
        if (
          this.productEntryLocalItems._array.length != 0 &&
          this.productEntryLocalItems._array[
            this.productEntryLocalItems._array.length - 1
          ].Code
        )
          this.productEntryLocalItems.push([{ type: "insert", data: dataObj }]);
        else if (this.productEntryLocalItems._array.length == 0)
          this.productEntryLocalItems.push([{ type: "insert", data: dataObj }]);
      } else if (type == "update")
        this.productEntryLocalItems.push([
          {
            type: "update",
            key: dataObj.ID,
            data: dataObj,
          },
        ]);

      // await this.setStockPrices(dataObj);
      // await this.setLineTotals(dataObj);

      this.setFooterItems(this.productEntryLocalItems._array);
      var dataGrid = this.$refs["dx-data-grid-comp"].instance;
      dataGrid.refresh(true);
    },
    backButtonFunction() {
      this.$router
        .push({
          path: this.backButtonRoute,
        })
        .then(() => {
          this.$store.dispatch("dataContext/setDataViewType", undefined);
        });
    },

    // Save Transaction
    async saveTransaction(isValid, brokenRules) {
      if (!isValid) this.displayValidationSummary(brokenRules);
      else {
        // this.saveSalesOrder(this.model);
      }
    },

    // Start - Details Data Grid Functions

    onToolbarPreparing(e) {
      e.toolbarOptions.items.push({
        location: "before",
        widget: "dxButton",
        options: {
          icon: undefined,
          text: "Search",
          elementAttr: {
            class: "cx-color-button",
          },
          onClick: () => {
            // this.visibleProductSearch();
          },
          visible: this.baseView.mode != "review",
        },
      });

      e.toolbarOptions.items.push({
        location: "after",
        locateinmenu: "auto",
        widget: "dxButton",
        // visible: !this.isTablet,
        options: {
          icon: this.gridExpand ? "collapse" : "expand",
          onClick: this.expandGrid,
        },
      });
    },
    expandGrid() {
      this.$store.dispatch("ui/setGridExpand", !this.gridExpand);
      setTimeout(() => {
        var dataGrid = this.$refs["dx-data-grid-comp"].instance;

        dataGrid.beginUpdate();
        dataGrid.updateDimensions();
        dataGrid.endUpdate();

        dataGrid.refresh(true);
      }, 500);
    },
    // End - Details Data Grid Functions

    // Start - Header Form Functions

    // End - Header Form Functions

    // Start - On initialized Functions
    async initialized() {
      this.setFooterItems([]);
      if (this.baseView.mode == "create") {
        this.loaded = true;
        this.showLoading(false);
      } else {
        this.loaded = true;
        this.showLoading(false);
      }
      // this.loaded = true;

      var dataGrid = this.$refs["dx-data-grid-comp"].instance;
      dataGrid.refresh(true);
    },
    // End - On initialized Functions

    // Footer

    async setFooterItems(gridItems) {
      this.showFooter = false;
      await this.getFooterItems
        .filter((x) => (x.hasOwnProperty("visible") ? x.visible : true))
        .forEach((x) => {
          x.value = this.updateValue(x.dataField, gridItems);
          if (x.customCalc) x.value = x.customCalc(this.model, gridItems);
        });
      this.footerItems = this.getFooterItems;
      this.showFooter = true;

      // var dataGrid = this.$refs["dx-data-grid-comp"].instance;
      // dataGrid.refresh(true);
    },
    updateValue(dataField, items) {
      let result = 0;
      if (items.length > 0)
        items.forEach((x) => {
          if (x.CheckInclude || this.baseView.mode == "review")
            result += parseFloat(x[dataField]).roundNumber(4);
          else if (x.CheckInclude == undefined)
            result += parseFloat(x[dataField]).roundNumber(4);
        });

      return result;
    },
  },
  watch: {
    async getValidationSummaryVisible(val) {
      if (!val && this.validationLineData == "Customer") {
        if (this.gridExpand) await this.expandGrid();
        this.validationLineData = undefined;
        var headerToolBarForm = this.$refs["gc-header-form-component"].$refs[
          "gc-form-header-toolbar"
        ].$refs["toolbar-form"].$refs["gc-form-comp"].instance;
        if (headerToolBarForm) {
          headerToolBarForm.getEditor("CustomerCode").focus();
          var cusDropdown = headerToolBarForm
            .getEditor("CustomerCode")
            .instance();
          cusDropdown.open();
        }
      } else if (!val && this.validationLineData) {
        // this.focusOnGridCell(
        //   this.validationLineData.rowIndex,
        //   this.validationDataField
        //     ? this.validationDataField
        //     : this.validationLineData.column.dataField
        // );
        var dataGrid = this.$refs["dx-data-grid-comp"].instance;
        var rowIndex = dataGrid.getRowIndexByKey(this.validationDataField);
        var cellElement = dataGrid.getCellElement(rowIndex, "ProductCode");
        dataGrid.focus(cellElement);
        dataGrid.editCell(rowIndex, "ProductCode");

        var index = this.productEntryLocalItems._array.findIndex(
          (x) => x.ID == this.validationDataField
        );
        if (index != -1) {
          if (this.productEntryLocalItems._array[index].validCode) {
            dataGrid.cellValue(
              rowIndex,
              "ProductCode",
              this.productEntryLocalItems._array[index].validCode
            );
          }
        }

        this.validationLineData = undefined;
        this.validationDataField = undefined;
      }
    },
  },
};
</script>

<style lang="scss">
.sales-order-v2 {
  .dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td {
    vertical-align: middle !important;
  }
}
</style>
